import React from 'react'
import { Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { addMessage, deleteMessage } from "../Actions/messages";
import { setLogin } from "../Actions/auth";
import BI from "../Images/loginBG.jpg";
import PasswordIcon from "../Images/lock-7-16.png";
import "../App.css";

class Login extends React.Component {
    constructor() {
        super();
        this.state = {
            password: ""
        };
    }
    moveToAdminDashboard = () => {
        fetch(`https://us-central1-portfolio-336c8.cloudfunctions.net/logIn?password=${this.state.password}`).then(res => res.json()).then(data => {
            if (data.status === true) {
                this.props.deleteMessage();
                this.props.setLogin();
                sessionStorage.token = data.token;
                this.props.history.push("/admin");
            } else {
                this.props.addMessage("Password is incorrect!", "danger");
            }
        });
    }
    handleDismiss = () => {
        this.props.deleteMessage();
    }
    render() {
        return (
            <div style={styles.loginContainer} className="loginContainer">
                {this.props.message.message && <Alert bsStyle={this.props.message.messageType} onDismiss={this.handleDismiss} style={styles.passwordErrAlert} className="errPasswordAlert animated fadeIn">{this.props.message.message}</Alert>}
                <div style={styles.AdminSignShower}>A</div>
                <form action="JavaScript:void(0)" onSubmit={this.moveToAdminDashboard}>
                    <input type="password" style={styles.loginField} className="loginField" onChange={e => { this.setState({ password: e.target.value }); }} placeholder="Password" />
                    <button type="submit" style={styles.loginBTN}>Log In</button>
                </form>
            </div>
        );
    }
}

const styles = {
    loginContainer: {
        backgroundImage: `url(${BI})`,
        width: "100%",
        height: window.innerHeight,
        fontFamily: "Roboto, sans-serif",
        paddingTop: 200
    },
    AdminSignShower: {
        width: 80,
        height: 80,
        borderRadius: 80,
        border: "4px solid #ecf0f1",
        color: "#ecf0f1",
        fontWeight: "bold",
        textAlign: "center",
        fontSize: 40,
        paddingTop: 6,
        margin: "auto"
    },
    loginField: {
        border: 0,
        borderBottom: "2px solid #7f8c8d",
        backgroundColor: "transparent",
        outline: "none",
        backgroundImage: `url(${PasswordIcon})`,
        backgroundRepeat: "no-repeat",
        paddingTop: 5,
        paddingLeft: 30,
        paddingRight: 5,
        paddingBottom: 5,
        backgroundPosition: "8px 7px",
        color: "#fff",
        width: 200,
        position: "relative",
        left: "50%",
        top: 50,
        transform: "translateX(-50%)",
    },
    loginBTN: {
        color: "#fff",
        backgroundColor: "#C80A48",
        width: 220,
        height: 50,
        border: 0,
        borderRadius: 50,
        display: "block",
        position: "relative",
        left: "50%",
        transform: "translateX(-50%)",
        top: 80,
        outline: "none"
    },
    passwordErrAlert: {
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        top: "10%",
        transition: "all .40s ease"
    }
};

export default connect(state => ({ message: state.message }), { addMessage, deleteMessage, setLogin })(Login);



// WEBPACK FOOTER //
// ./src/Components/logIn.jsx